import { paymentRoute } from './payment';

export const allPaymentRoutes = [paymentRoute()];
